import CiBlockMap from "./ciblock-map";

export default CiBlockMap;